/* eslint-disable */
import {
  Box,
  Typography,
  Card,
} from '@mui/material';
import { useAppSelector } from '../../../store/hooks';


const MRRSubscriptionTierCard = () => {
  const subscriptionTierMRR = useAppSelector(state => state.whiltelabelSlice.subscriptionTierMRR)
  return (
    <Card
      sx={{
        p: 4, borderRadius: 3, width: '100%', height: '100%'
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.1,
          mb: 1,
        }}
      >
        MRR by Subscription Tier
      </Typography>
      {subscriptionTierMRR.breakdown.length === 0
        ?
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'gray' }}>
          No subscription Yet
        </Box>
        :
        <Box>
          {subscriptionTierMRR.breakdown.map((item) => (
            <Box
              key={item.tier}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: 13,
                mb: 1.5,
              }}
            >
              <Typography>{item.tier}</Typography>
              <Box sx={{ textAlign: "right" }}>
                <Typography sx={{ fontWeight: 600 }}>{item.value}</Typography>
                <Typography sx={{ color: "#718096", fontSize: 11 }}>{item.percentage}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      }
    </Card>
  )
}

export default MRRSubscriptionTierCard;